import React, { useState } from 'react'

import {
  Box,
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography
} from '@mui/material'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import { useApi } from '../../../hooks/useApi'
import axios from 'axios'
import { ApiConfig } from '../../../config/api'

import * as Yup from 'yup'
import { PickingRoute } from '../../../interfaces/Picking/Picking'
import { Status } from '../../../hooks/useFetchState'

interface ModifyLPNProps {
  pickingRoute: PickingRoute
  updatePickingRoute: React.Dispatch<
    React.SetStateAction<PickingRoute | undefined>
  >
  goBack: () => void
}

interface CreateLPN {
  pickingRouteId: number | undefined
  LPN: string
}

export const validationSchema = Yup.object().shape({
  LPN: Yup.string()
    .trim()
    .min(1, 'Se requiere al menos un caracter')
    .required('LPN es obligatorio')
})

const createLPN = (body: CreateLPN) => {
  const url = new URL(
    `${ApiConfig.PickingRouteApi}/UpdateLPN/${body.pickingRouteId}`
  )
  return axios.put(url.toString(), { lpn: body.LPN })
}

export const ModifyLPNStep: React.FC<ModifyLPNProps> = ({
  goBack,
  updatePickingRoute,
  pickingRoute
}) => {
  const [error, setError] = useState('')

  const { state, callApi } = useApi()

  const requestCreateAsn = async (dto: CreateLPN) => {
    await callApi(createLPN(dto))
      .then(() => {
        updatePickingRoute((el) => {
          if (el !== undefined) {
            return { ...el, lpn: dto.LPN.trim() }
          }

          return el
        })
      })
      .then(goBack)
      .catch(() => setError('LPN ya ha sido registrado previamente.'))
  }

  const handleSubmit = async (values: CreateLPN) => {
    values.pickingRouteId = pickingRoute.pickingRouteId
    await requestCreateAsn(values)
  }

  return (
    <Grid
      container
      spacing={3}
      direction='column'
      alignItems='center'
      justifyContent='space-between'
    >
      <Grid item xs={12}>
        <Formik
          initialValues={{
            LPN: pickingRoute.lpn || '',
            pickingRouteId: 0
          }}
          validationSchema={validationSchema}
          onSubmit={async (values) => new Promise(() => handleSubmit(values))}
        >
          {({ isValid }) => (
            <Form>
              <Box display='flex' alignItems='center' p={1} m={1}>
                <Field
                  fullWidth
                  as={TextField}
                  type='text'
                  name='LPN'
                  label='Ingresar LPN'
                  variant='outlined'
                  InputLabelProps={{
                    shrink: true
                  }}
                  autoFocus
                  autoComplete='off'
                />
                <Button
                  type='submit'
                  variant='contained'
                  color='primary'
                  style={{ marginLeft: 10 }}
                  disabled={!isValid || state.status === Status.Loading}
                  startIcon={
                    state.status === Status.Loading && (
                      <CircularProgress size={20} />
                    )
                  }
                >
                  {'>'}
                </Button>
              </Box>

              <ErrorMessage name='LPN' component='div' />
              {error && (
                <Typography variant='body2' style={{ color: 'red' }}>
                  {error}
                </Typography>
              )}
            </Form>
          )}
        </Formik>
      </Grid>
      <Grid item xs={12}>
        <Button
          type='button'
          variant='contained'
          color='primary'
          onClick={goBack}
          size='small'
          fullWidth
          disabled={state.status === Status.Loading}
        >
          Cancelar
        </Button>
      </Grid>
    </Grid>
  )
}
